// Create the stickybits header outside of a Behaviour so it is only run once.
window.createSiteHeaderStickybits = () => {
  // Attach the stickybits to the window object so we can destroy it
  // from other scripts, e.g the course page on desktop.
  if (window.siteHeaderStickybits) {
    window.siteHeaderStickybits.cleanup();
  }

  window.siteHeaderStickybits = stickybits('#site-header', {
    useStickyClasses: true,
  });
};

(function siteHeaderWrapper($) {
  // eslint-disable-next-line no-unused-vars
  window.siteHeader = function siteHeader() {
    return {
      drilldownOpen: false,
      siteSearchOpen: false,
      itemsInOverflow: 0,
      overflowExpanded: false,
      drupalToolbarHeight: null,
      navigationSwitchBreakpoint: 'xl',
      searchFocusTrap: null,
      drilldownFocusTrap: null,
      submenuOpened: false,
      toggleDrilldown() {
        if (this.submenuOpened) {
          this.delayDrilldown();
          return false;
        }
        this.drilldownOpen = !this.drilldownOpen;

        if (this.drilldownOpen) {
          this.$nextTick(() => {
            // primary-navigation.js listens for this event and only sets up
            // the mobile nav once a user has requested it. This means less
            // JS and DOM work on the initial page load, which is good for
            // performance.
            document.dispatchEvent(new Event('create-drilldown'));
          });
        }
      },
      delayDrilldown() {
        const self = this;
        if (self.drilldownOpen) {
          // Return the drilldown to level 0 on toggle action.
          $('[data-drilldown]').foundation('_hideAll');
          // We delay the actual variable change until drilldown has been reset
          // to level 0.
          _.delay(function delayDrilldownFn() {
            self.drilldownOpen = false;
            self.submenuOpened = false;
          }, 500);
        }
      },
      toggleSiteSearchOpen() {
        this.siteSearchOpen = !this.siteSearchOpen;
      },
      toggleMoreMenu() {
        this.overflowExpanded = !this.overflowExpanded;
        // Focus the first item in the overflow on the 'nextTick' e.g. once
        // Alpine has finished updating the DOM.
        this.$nextTick(() => {
          Foundation.Keyboard.findFocusable($(this.$refs['nav-overflow']))
            .first()
            .focus();
        });
      },
      blockPageUsage() {
        // Block page usage. We create the mobile menu lazily (e.g. only when
        // a user opens the mobile menu) so we need to wait until the element
        // is available before we can call body-scroll-lock.
        function waitForDrilldownThenLockBodyScroll() {
          if (!document.querySelector('[data-drilldown]')) {
            window.requestAnimationFrame(waitForDrilldownThenLockBodyScroll);
          } else {
            // @see https://github.com/willmcpo/body-scroll-lock
            window.bodyScrollLock.disableBodyScroll(
              document.querySelector('[data-drilldown]'),
            );

            document.body.classList.remove('u-overflow-y-scroll');
          }
        }
        waitForDrilldownThenLockBodyScroll();

        // `inert` prevents focusing of the main and footer elements and also
        // hides them from assistive tech like screenreaders. We use opacity to
        // hide the main and footer content rather than display:none to avoid
        // the page layout jumping up and down.
        $('main,.above-footer,footer')
          .addClass('u-opacity-0')
          .attr('inert', true);
      },
      allowPageUsage() {
        window.bodyScrollLock.enableBodyScroll(
          document.querySelector('[data-drilldown]'),
        );

        document.body.classList.add('u-overflow-y-scroll');

        $('main,.above-footer,footer')
          .removeClass('u-opacity-0')
          .removeAttr('inert');
      },
      setHeaderHeightProperty() {
        const root = document.documentElement;

        root.style.setProperty(
          '--site-header-height',
          `${this.$el.clientHeight}px`,
        );
      },
      calculateNewHeaderHeightProperty() {
        // Pause the execution of the setHeaderHeightProperty function so that
        // any transitions can finish.
        _.delay(this.setHeaderHeightProperty.bind(this), 350);
      },
      init($watch) {
        window.createSiteHeaderStickybits();
        this.closeMobileMenuOnLanguageSwitcherInit();

        window.addEventListener('load', function updateStickybitsHeader(event) {
          // Update the sticky header's Stickybits instance once the page has
          // loaded, to take into account if the page height has changed due to
          // images loading.
          window.siteHeaderStickybits.update();
        });

        this.setHeaderHeightProperty();

        // eslint-disable-next-line no-undef
        $watch('drilldownOpen', value => {
          if (value === true) {
            this.siteSearchOpen = false;
            this.blockPageUsage();
            // Unfortunately, we can't use focus-trap here as it clashes with
            // Foundation's keyboard nav events.
          } else {
            this.allowPageUsage();
          }
        });

        // eslint-disable-next-line no-undef
        $watch('siteSearchOpen', value => {
          if (value === true) {
            this.drilldownOpen = false;

            this.$nextTick(() => {
              // Focus the search field. Not sure if this is great for a11y as
              // it's not coming from the user, but it saves people needing to
              // tab or click on the search field, and we can probably assume
              // that someone who clicks the 'search' button is interested in
              // searching.
              $('.site-header-search')
                .find("input[name='query']")
                .focus();

              // Limit keyboard nav to just the search bar and the buttons to
              // either close the search bar or open the mobile nav.
              this.createFocusTrap(
                'searchFocusTrap',
                ['[data-site-header-buttons]', '.site-header-search-wrapper'],
                'search bar',
              );
            });
          } else {
            this.deactivateFocusTrap('searchFocusTrap');
          }
        });

        $('[data-dropdown-menu]').on('show.zf.dropdownMenu', () => {
          this.siteSearchOpen = false;
          this.overflowExpanded = false;
        });

        $('[data-drilldown]').on('open.zf.drilldown', () => {
          // Submenu has been opened variable.
          this.submenuOpened = true;
        });

        $('[data-drilldown]').on('hide.zf.drilldown', () => {
          // Submenu has been closed variable.
          this.submenuOpened = false;
        });

        // If the breakpoint changes, close everything as a precaution, otherwise
        // the page can get stuck with page usage blocked.
        $(window).on('changed.zf.mediaquery', () => {
          this.siteSearchOpen = false;
          this.delayDrilldown();
          this.calculateNewHeaderHeightProperty();
        });

        this.unstickyHeaderIfNoRoom();
      },
      createFocusTrap(id, selector, name) {
        const headerApp = this;
        const themePathLibraries = `/themes/custom/rutherford/libraries`;

        // We lazyload the focus-trap JS as we only need it if the user has
        // expanded the search bar, and not everyone will.
        if (!loadjs.isDefined('focus-trap')) {
          loadjs(
            [
              `${themePathLibraries}/tabbable/dist/index.umd.min.js`,
              `${themePathLibraries}/focus-trap/dist/focus-trap.umd.min.js`,
            ],
            'focus-trap',
          );
        }

        loadjs.ready('focus-trap', {
          success() {
            // Once the focus-trap library has loaded, we use it to create a
            // focus trap.
            headerApp[id] = window.focusTrap
              .createFocusTrap(selector, {
                preventScroll: true,
                allowOutsideClick: true,
              })
              .activate();
          },
        });

        Drupal.announce(
          Drupal.t(`Keyboard tabbing is constrained to the ${name}.`),
        );
        Drupal.announce(
          Drupal.t('Press the ESC key or use the Close button to exit.'),
        );
      },
      deactivateFocusTrap(id) {
        if (_.isObject(this[id])) {
          this[id].deactivate();
        }
      },
      unstickyHeaderIfNoRoom() {
        const className = 'sticky-header-removed-due-to-height';

        const viewportHeight = Math.max(
          document.documentElement.clientHeight || 0,
          window.innerHeight || 0,
        );

        // We were originally using window.matchMedia and a min-height query
        // here, but it caused issues with Safari not updating when the address
        // and menu bar disappear, so we use a JS rather than CSS approach
        // instead.
        if (viewportHeight < 600) {
          // We have to wait till the next tick otherwise the DOM isn't ready
          // for Stickbits to clean up and it doesn't work properly. We don't use
          // this.$nextTick() here, because the next Alpine tick might not be for
          // a while if this is getting fired by a resize event. A tick only happens
          // when Alpine makes DOM updates, e.g. when a user expands the search form
          // or something like that.
          setTimeout(() => {
            window.siteHeaderStickybits.cleanup();
            document.body.classList.add(className);
          }, 0);
        } else if (!window.siteHeaderStickybits.instances.length) {
          window.createSiteHeaderStickybits();
          document.body.classList.remove(className);
        }
      },
      closeMobileMenuOnLanguageSwitcherInit() {
        $('[data-mobile-navigation] .language-switcher-link').on('click', () => {
          this.toggleDrilldown();
        });
      }

    };
  };
})(jQuery);
